import type { UseFormRegister, UseFormWatch } from 'react-hook-form'
import { Checkbox, Select } from '@/components'

const HOUR_OPTIONS = Array.from({ length: 24 }, (_, h) => ({
    value: h,
    label: h === 0 ? '12:00 AM' : h < 12 ? `${h}:00 AM` : h === 12 ? '12:00 PM' : `${h - 12}:00 PM`,
}))

// Sunday first, so the value is the index and matches System.DayOfWeek on the server with no
// translation either side.
const DAY_OPTIONS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    .map((label, value) => ({ value, label }))

interface WorkspaceStartOfWeekSummaryFieldsProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    register: UseFormRegister<any>
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    watch: UseFormWatch<any>
}

/**
 * The start-of-week summary toggle and the send day and hour it reveals.
 *
 * Its own component, unlike the post-webinar toggle: the cadence fields only make sense while the
 * summary is enabled, so a workspace with it off never collects a schedule it would not use — the
 * same reasoning as the daily leads summary next to it.
 */
export function WorkspaceStartOfWeekSummaryFields({ register, watch }: WorkspaceStartOfWeekSummaryFieldsProps) {
    return (
        <>
            <Checkbox
                label="Start-of-Week Summary"
                description="Email each workspace's reviewers a weekly status update covering every active demand web — broadcast dates, registrant counts, remaining email sends and anything still awaiting sign-off. Nothing is sent in a week with no active webs."
                {...register('StartOfWeekSummaryEnabled')}
            />
            {watch('StartOfWeekSummaryEnabled') && (
                <div className="ml-7 flex items-center gap-2">
                    <Select
                        label="Send on"
                        labelSize="xs"
                        options={DAY_OPTIONS}
                        placeholder="Select day"
                        containerClassName="w-40"
                        {...register('StartOfWeekSummaryDayOfWeek', { valueAsNumber: true })}
                    />
                    <Select
                        label="At"
                        labelSize="xs"
                        options={HOUR_OPTIONS}
                        placeholder="Select hour"
                        containerClassName="w-40"
                        {...register('StartOfWeekSummaryHour', { valueAsNumber: true })}
                    />
                    <span className="text-xs text-slate-500 dark:text-slate-400 mt-5">(workspace time zone)</span>
                </div>
            )}
        </>
    )
}
